import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Feature Icons (Tabler)
const ChannelsCenterFeatureIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-channels-center-feature${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z"
      id="icon-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33334 7.33333L4.66667 7.99999L5.33334 8.66666"
      id="icon-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33333 5.33333L7.99999 4.66666L8.66666 5.33333"
      id="icon-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6667 7.33333L11.3333 7.99999L10.6667 8.66666"
      id="icon-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33333 10.6667L7.99999 11.3333L8.66666 10.6667"
      id="icon-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default ChannelsCenterFeatureIcon;
